import React, { useState, useEffect } from 'react';
import { collection, getDocs } from "firebase/firestore";

// ============================================================================
// COMPONENTE: TransactionModal (v58)
// ============================================================================
const TransactionModal = ({ isOpen, onClose, onSave, material, db, user }) => {
    const [transaction, setTransaction] = useState({
        type: 'Entrada',
        quantity: '',
        jobId: '',
        notes: '',
    });
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        if (isOpen) {
            // Resetear el formulario cada vez que se abre
            setTransaction({ type: 'Entrada', quantity: '', jobId: '', notes: '' });

            // Cargar la lista de jobs para el selector
            const fetchJobs = async () => {
                try {
                    const jobsSnapshot = await getDocs(collection(db, "jobs"));
                    const jobsData = jobsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setJobs(jobsData.sort((a, b) => b.jobNumber - a.jobNumber)); // Ordenar por más reciente
                } catch (error) {
                    console.error("Error cargando jobs:", error);
                }
            };
            fetchJobs();
        }
    }, [isOpen, db]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTransaction(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        if (!transaction.quantity || Number(transaction.quantity) <= 0) {
            alert("La cantidad debe ser un número mayor a cero.");
            return;
        }
        if (transaction.type === 'Salida por Job' && !transaction.jobId) {
            alert("Debe seleccionar un Job para este tipo de salida.");
            return;
        }

        const dataToSave = {
            ...transaction,
            quantity: Number(transaction.quantity),
            date: new Date(),
            userId: user.uid,
            userEmail: user.email,
        };
        onSave(material.id, dataToSave);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <h2 className="text-2xl font-bold mb-2">Registrar Movimiento de Inventario</h2>
                <p className="text-sm text-gray-600 mb-6">Material: <span className="font-semibold">{material.name}</span></p>
                
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Tipo de Movimiento</label>
                        <select name="type" value={transaction.type} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md">
                            <option value="Entrada">Entrada (Compra / Devolución)</option>
                            <option value="Salida por Job">Salida (Consumo por Job)</option>
                            <option value="Ajuste de Salida">Ajuste de Salida (Pérdida / Desperdicio)</option>
                            <option value="Ajuste de Entrada">Ajuste de Entrada (Corrección)</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Cantidad</label>
                        <input type="number" name="quantity" value={transaction.quantity} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="0" min="0"/>
                    </div>
                    {transaction.type === 'Salida por Job' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Job Asociado</label>
                            <select name="jobId" value={transaction.jobId} onChange={handleChange} className="mt-1 block w-full p-2 border border-gray-300 rounded-md">
                                <option value="">-- Seleccionar Job --</option>
                                {jobs.map(job => (
                                    <option key={job.id} value={job.id}>
                                        {job.id} - {job.jobName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Notas / Referencia</label>
                        <textarea name="notes" value={transaction.notes} onChange={handleChange} rows="3" className="mt-1 block w-full p-2 border border-gray-300 rounded-md" placeholder="Ej: Orden de Compra #12345, Factura #678, Consumo para pieza 'Panel Trasero'"></textarea>
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-8">
                    <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300">Cancelar</button>
                    <button onClick={handleSave} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Guardar Movimiento</button>
                </div>
            </div>
        </div>
    );
};

export default TransactionModal;
